import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  useTheme,
} from "@mui/material";

const VendorOwnerSelect = ({
  value = "",
  onChange,
  people = [],
  label = "Owner",
  size = "small",
  required = false,
  fullWidth = true,
}) => {
  const theme = useTheme();
  const labelId = `${label.replace(/\s+/g, "-").toLowerCase()}-select-label`;

  return (
    <FormControl fullWidth={fullWidth} size={size} required={required}>
      <InputLabel id={labelId} shrink>
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        value={value || ""}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        notched
        renderValue={(selected) => {
          if (!selected) return "Select owner";
          const person = people.find((p) => p.email === selected);
          return person ? person.name : selected;
        }}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.customColors.border.main,
          },
        }}
      >
        <MenuItem value="">
          <Typography variant="body2" sx={{ color: theme.customColors.text.disabled, fontStyle: "italic" }}>
            Unassigned
          </Typography>
        </MenuItem>
        {people.map((person) => (
          <MenuItem key={person.email} value={person.email}>
            <Box>
              <Typography variant="body2" fontWeight={500}>
                {person.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {person.email}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default VendorOwnerSelect;
